module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.0-111.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.0.md
// module id = 527
// module chunks = 291